import { useLocation } from "react-router-dom";

export type AppContext = "default" | "crmon";

export function useAppContext(): AppContext {
  const { pathname } = useLocation();
  if (pathname.startsWith("/crmon")) return "crmon";
  return "default";
}
